import { render, staticRenderFns } from "./OrderableCartItemSectionCustom.vue?vue&type=template&id=8d9156b0&"
import script from "./OrderableCartItemSectionCustom.vue?vue&type=script&lang=ts&"
export * from "./OrderableCartItemSectionCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports